import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import SaleProvider from "./context/SaleProvider";
import { HelmetProvider } from 'react-helmet-async';

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
    <SaleProvider>
      <App />
    </SaleProvider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
